export default class PageSelect extends HTMLElement {
  constructor() {
    super();

    if (!this.select) return;

    this.select.addEventListener("change", (event) => {
      const value = event.target.value;
      if (value && value !== window.location.pathname) {
        window.location.assign(`${value}`);
      }
    });
  }

  get select() {
    return this.querySelector("select");
  }
}
